import { Console } from "console"
import MarkerInfo, { AnchorState } from "../../models/MarkerInfo"

export interface MarkersProps {
    list?: MarkerInfo[]
    edit?: boolean
    onMarkerClickCallback?: (markerInfo: MarkerInfo, infoWindow: google.maps.InfoWindow)=>void
    onMarkerDragCallback?: (id: string, marker: google.maps.Marker, event: google.maps.MapMouseEvent)=>void
}

export class MarkersLayer {
    map: google.maps.Map
    config: MarkersProps | undefined
    gmarks: google.maps.Marker[] = []
    infoWindow = new google.maps.InfoWindow()

    constructor(map: google.maps.Map, config: MarkersProps | undefined) {
        this.map = map
        this.configure(config)
    }

    configure(config: MarkersProps | undefined) {
        console.log("MarkersLayer.configure")
        this.config = config

        // cleanup old markers
        for (const mark of this.gmarks) {
            mark.setMap(null)
        }
        this.gmarks = []

        // create new markers
        if (config?.list) {
            for (const info of config.list) {
                this.gmarks.push(this.createMarker(info))
            }
        }
    }

    onMarkerClick(marker: google.maps.Marker, info: MarkerInfo) {
        //this.infoWindow.setContent(`<p style="color:black;">${info.title}</p>`);
        this.infoWindow.setContent(`<pre style="color:black;">${info.popupInfo}</pre>`);
        this.infoWindow.open(undefined, marker);
        if (this.config?.onMarkerClickCallback) {
            this.config?.onMarkerClickCallback(info, this.infoWindow)
        }
    }

    createMarker(info: MarkerInfo) {
        let draggable = this.config?.edit && info.state != AnchorState.Error
        console.log(`MARK drag: ${draggable}`)
        let marker = new google.maps.Marker({
            map: this.map,
            position: info.pos,
            icon: info.icon,
            title: info.title,
            draggable: draggable
        });
        marker.addListener('click', () => this.onMarkerClick(marker, info));
        if (this.config?.onMarkerDragCallback) {
            marker.addListener('dragend', (event: google.maps.MapMouseEvent)=> {
                if (this.config?.onMarkerDragCallback) {
                    this.config?.onMarkerDragCallback(info.id, marker, event)
                }
            })
        }
        return marker;
    }

    getBounds() {
        if (this.gmarks.length == 0) {
            return null
        }

        let bounds = new google.maps.LatLngBounds();
        for (const marker of this.gmarks) {
            bounds.extend(marker.getPosition()!);
        }

        return bounds
    }

    onMapClick(event: google.maps.MapMouseEvent) {
        this.infoWindow.close();
    };
}